export default "__VITE_ASSET__DFPiVTnb__"